<template>
  <div class="page">
    <Header title="取消订购" />
    <OrderDetailBox :detailItem="detailOrderInfo" height="2rem"></OrderDetailBox>
    <van-cell title="货物状态" value="未发货"></van-cell>
    <van-cell is-link title="取消原因" :value="orderCancelReason.name || '请选择'" @click="show = true" />
    <van-field v-model="reasonObj.returnOtherReason" v-if="orderCancelReason.key === '99'" rows="4" type="textarea"
      placeholder="请输入其他原因" />
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" cancel-text="取消" />
    <van-cell title="卡券使用状态" :value="orderInfo.couponInfo ? '已使用' : '未使用'"></van-cell>
    <van-cell title="退还积分" :value="detailOrderInfo.pointTypeName + '：' + detailOrderInfo.detailPoint[0].pointValue"
      value-class="back-point-red"></van-cell>
    <div class="cancel-button">
      <van-button type="primary" plain size="small" @click="submit">确定取消</van-button>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import OrderDetailBox from '@/components/order-detail-box.vue'
import wxAppApi from '@/api/wx-app'
import cartApi from '@/api/cart'
import { mapState } from 'vuex'
export default {
  components: {
    Header,
    OrderDetailBox
  },
  data () {
    return {
      itemId: '',
      orderId: '',
      orderDetailId: '',
      orderInfo: [],
      detailOrderInfo: {},
      show: false,
      actions: [{ name: '不想要了', key: '01' }, { name: '下单错误', key: '02' }, { name: '其他', key: '99' }],
      orderCancelReason: {
        name: '',
        key: ''
      },
      reasonObj: {
        returnOtherReason: '' // 其他原因
      }
    }
  },
  created () {
    if (this.userRole === '03') {
      this.$toast('没有查看订单详情的权限')
    } else {
      this.init()
    }
  },
  computed: {
    ...mapState({
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    })
  },
  methods: {
    init () {
      this.itemId = this.$route.params.itemId
      this.orderId = this.$route.params.orderId
      this.orderDetailId = this.$route.params.orderDetailId
      this.queryItemInfo()
    },
    queryItemInfo () {
      let params = {
        orderId: this.orderId || ''
      }
      wxAppApi.queryItemInfo(params).then(res => {
        if (res.data.resultCode === '0') {
          this.orderInfo = res.data.resultData.orderInfo
          this.detailOrderInfo = this.orderInfo.detailList.find(item => {
            return item.itemId === this.itemId
          })
        }
      })
    },
    // 取消原因
    onSelect (item) {
      this.orderCancelReason = item
      this.show = false
      if (this.orderCancelReason.key === '99') {
        this.reasonObj.returnOtherReason = ''
      }
    },
    // 确定取消
    submit () {
      if (!this.orderCancelReason.key) {
        this.$toast('请选择取消原因')
        return
      }
      let data = {
        orderId: this.orderId,
        orderDetailId: this.orderDetailId,
        itemId: this.itemId,
        returnReason: this.orderCancelReason.key,
        returnDesc: this.reasonObj.returnOtherReason
      }
      this.$toast.loading({
        duration: 0,
        message: '提交中...',
        forbidClick: true
      })
      cartApi.cancelOrder(data).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          this.$toast('取消成功')
          this.$router.push({
            name: 'userOrder'
          })
        }
      }).catch(() => { this.$toast.clear() })
    }
  }
}
</script>
<style  scoped lang="less">
.back-point-red {
  color: #e20015;
}

.cancel-button {
  background-color: #fff;
  padding: 0.2rem;
  text-align: center;
}
</style>
